// [width, height]

export default {
  arrowLeft: [10, 16],
  arrowRight: [10, 16],
  map: [52, 18],
  phone: [20, 20],
};
